import { useState, type FormEvent } from 'react';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button, Field, PasswordField } from '../../shared/ui/components';

/** «¿Te equivocaste de correo?»: antes de confirmarlo, se corrige con la contraseña y el enlace llega al correo nuevo. */
export function ChangeEmail({ email, onChanged }: { email: string; onChanged: (newEmail: string) => void }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!open) {
    return (
      <p className="small">
        <button type="button" className="link-button" onClick={() => setOpen(true)}>
          ¿Te equivocaste de correo? Corrígelo aquí
        </button>
      </p>
    );
  }
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    const newEmail = String(f.get('newEmail') ?? '').trim().toLowerCase();
    setBusy(true);
    setError(null);
    try {
      await api.post('/identity/email-verifications/change-email', { email, password: String(f.get('password') ?? ''), newEmail });
      setOpen(false);
      onChanged(newEmail);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }
  return (
    <form className="form change-email" onSubmit={submit} noValidate>
      <p className="small muted">
        Escribiste <strong>{email}</strong>. Pon tu contraseña y el correo correcto; te enviaremos ahí el enlace para confirmarlo.
      </p>
      {error ? <Alert>{error}</Alert> : null}
      <PasswordField label="Tu contraseña" name="password" autoComplete="current-password" required />
      <Field label="Correo correcto" name="newEmail" type="email" autoComplete="email" required />
      <div className="actions">
        <Button type="submit" busy={busy}>
          Corregir y enviar enlace
        </Button>
        <Button variant="ghost" onClick={() => setOpen(false)}>
          Cancelar
        </Button>
      </div>
    </form>
  );
}
